<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Região</h4>
              <a class="heading-elements-toggle"
                ><i class="fa fa-ellipsis-v font-medium-3"></i
              ></a>
              <div class="heading-elements">
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="onCreate()"
                      v-b-tooltip
                      title="Cadastrar"
                      v-if="getPermissionFw('regiao.store')"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </li>                  
                  <li>
                    <a
                      @click="onFilterReset()"
                      v-b-tooltip
                      title="Atualizar listagem"
                      ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onExtrairRelatorio()"
                      v-b-tooltip
                      title="Extrair Relatório de Regiões"
                      v-if="getPermissionFw('regiao.index')"
                      ><i class="fa fa-print"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onImport()"
                      v-b-tooltip
                      title="Importar Regiões"
                      v-if="getPermissionFw('regiao.index')"
                      ><i class="fa fa-code step-xml-nfe"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHideFw()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermissionFw('regiao.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inutilizar Registros"
                      v-if="getPermissionFw('regiao.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar :tabela="'regiao'"> </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/regiao"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="regiao_id"
                    pagination-path=""
                    detail-row-component="regiao-detalhes"
                    @vuetable:cell-clicked="onDetail"
                    @vuetable:load-error="onError"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>

                    <template slot="tp_fluxo" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.tp_fluxo.valor == 1"
                        >{{ props.rowData.tp_fluxo.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.tp_fluxo.valor == 2"
                        >{{ props.rowData.tp_fluxo.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.tp_fluxo.valor == 3"
                        >{{ props.rowData.tp_fluxo.descr }}</span
                      >
                    </template>

                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                          @click="onEdit(props.rowData, props.rowIndex)"
                          v-b-tooltip
                          title="Editar"
                          v-if="getPermissionFw('regiao.update')"
                          ><i class="fa fa-edit"></i
                        ></a>
                        <span v-if="getPermissionFw('regiao.status')">
                          <a
                            v-if="props.rowData.status.valor == 2"
                            @click="
                              onActivateDesactivate(1, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Ativar"
                            ><i class="fa fa-thumbs-o-up"></i
                          ></a>
                          <a
                            v-if="props.rowData.status.valor == 1"
                            @click="
                              onActivateDesactivate(2, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Inativar"
                            ><i class="fa fa-thumbs-o-down"></i
                          ></a>
                        </span>
                        <a
                          @click="onCreateUf(props.rowData.regiao_id)"
                          v-b-tooltip
                          title="Vincular UF"
                          ><i class="fa fa-bullseye"></i
                        ></a>
                        <a
                          @click="onCreateMunicipio(props.rowData.regiao_id)"
                          v-b-tooltip
                          title="Vincular Município"
                          ><i class="fa fa-building-o"></i
                        ></a>
                        <a
                          @click="
                            onCreateCep(props.rowData.regiao_id, props.rowData)
                          "
                          v-b-tooltip
                          title="Vincular Faixa de CEP"
                          ><i class="fa fa-map-marker"></i
                        ></a>
                        <a
                          @click="onDetail(props.rowData, null, null)"
                          v-if="
                            props.rowData.regiao_uf.length > 0 ||
                            props.rowData.regiao_municipio.length > 0 ||
                            props.rowData.regiao_cep.length > 0
                          "
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <RegiaoForm
        ref="regiaoform"
        :metodo="onFilterReset"
        :tabela="'regiao'"
        :rota="'regiao'"
      >
      </RegiaoForm>
      <RegiaoUfForm
        ref="regiaoufform"
        :metodo="onFilterReset"
        :tabela="'regiao_uf'"
        :rota="'regiaouf'"
      >
      </RegiaoUfForm>
      <RegiaoMunicipioForm
        ref="regiaomunicipioform"
        :metodo="onFilterReset"
        :tabela="'regiao_municioio'"
        :rota="'regiaomunicipio'"
      >
      </RegiaoMunicipioForm>
      <RegiaoCepForm
        ref="regiaocepform"
        :metodo="onFilterReset"
        :tabela="'regiao_cep'"
        :rota="'regiaocep'"
      >
      </RegiaoCepForm>
      <RegiaoImportarForm ref="regiaoimportarform" />
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import RegiaoFilterBar from "./RegiaoFilterBar";
import RegiaoForm from "./RegiaoForm";
import RegiaoUfForm from "./RegiaoUfForm";
import RegiaoMunicipioForm from "./RegiaoMunicipioForm";
import RegiaoDetalhes from "./RegiaoDetalhes";
import RegiaoCepForm from "./RegiaoCepForm.vue";
import RegiaoImportarForm from "./RegiaoImportarForm.vue";

Vue.component("regiao-detalhes", RegiaoDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    RegiaoForm,
    RegiaoUfForm,
    RegiaoCepForm,
    RegiaoMunicipioForm,
    RegiaoImportarForm,
    "vuetable-filterbar": RegiaoFilterBar
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      form: new Form({ cd: "", descr: "", regiao_id: "", status: [] }),
      helpForm: new Form({ statusRecord: [], status: "" }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned"
        },
        {
          name: "cd",
          title: "Código",
          sortField: "cd"
        },
        {
          name: "descr",
          title: "Descrição",
          sortField: "descr"
        },
        {
          name: "__slot:tp_fluxo",
          title: "Fluxo"
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status"
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned"
        }
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger"
      },
      moreParams: {}
    };
  },
  mounted() {
    this.$events.$on("filter-set", eventData => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", e => this.onFilterReset());
  },
  methods: {
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.regiao_id);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        cd: data_filter.cd,
        descr: data_filter.descr,
        municipio: data_filter.municipio.value,
        municipio_cep: data_filter.municipio_cep.value,
        status: data_filter.status.value
      };
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onLoaded: function() {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onExtrairRelatorio() {
      this.form
        .post("/api/regiao/export")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onCreate() {
      this.$refs.regiaoform.onCreate();
    },
    onEdit(data, index) {
      this.id = data.regiao_id;
      this.$refs.regiaoform.onEdit(data, index, this.id);
    },
    onImport(data) {
      this.$refs.regiaoimportarform.errors_array = [];
      this.$refs.regiaoimportarform.showModal = true;
    },
    onCreateUf(regiao) {
      this.$refs.regiaoufform.onCreate(regiao);
    },
    onCreateCep(regiao, data) {
      this.$refs.regiaocepform.onCreate(regiao, data);
    },
    onCreateMunicipio(regiao) {
      this.$refs.regiaomunicipioform.onCreate(regiao);
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.statusRecord = [];
        this.helpForm.statusRecord.push(data.regiao_id);
      } else {
        this.helpForm.statusRecord = [];
        this.$refs.vuetable.selectedTo.forEach(obj => {
          this.helpForm.statusRecord.push(obj);
        });
      }
      this.$refs.regiaoform.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      }
    }
  }
};
</script>
